import React from 'react';
import { connect } from 'react-redux';
import { Form } from 'semantic-grab-ui';

import { Col, Row } from 'grab-ui';
import _ from 'lodash';
import EventDropdown from 'omega-rtc/components/form/trident-campaigns/EventDropdown';
import {
    getConditionsFlag,
    getEventTypesList,
    getRuleTypesForConditionNode,
} from 'omega-rtc/utils/new-trident-utils';

import { GET_LIST_RULE_TYPE, getListRuleTypes } from 'omega-rtc/actions/newTridentExtra';
import ProgressiveContainer from 'omega-rtc/components/container/ProgressiveContainer';
import RuleBuilderConfig from 'omega-rtc/components/form/trident-campaigns/TreatmentRuleBuilderConfig';
import { RuleBuilder } from 'omega-rtc/components/rule-builder/RuleBuilder';
import { LIMIT_ITEMS, TRIDENT_OWNERS } from 'omega-rtc/constants/ucd';
import { TridentCampaignFormData } from 'omega-rtc/types/ucd/campaign';
import { isRequestsPending } from 'omega-rtc/utils/request-state-utils';
import { getRequestStateKey } from 'omega-rtc/utils/ucd-utils';
import ActionSection from 'omega-rtc/views/ucd/trident/pages/ActionSection';
import EventSection from 'omega-rtc/views/ucd/trident/pages/EventSection';
import LimitSection from 'omega-rtc/views/ucd/trident/pages/LimitSection';
import FormInputWithError from 'omega/components/form/FormInputWithError';
import './ScenarioPage.scss';

interface Props {
  country: any;
  targetUserType: string;
  listRuleTypes: any;
  getListRuleTypes: (owner: string, targetUserType: string) => void;
  getListRuleTypesRequest: any;
  handleFormDataChange: (data: any) => void;
  campaign: any;
  formData: TridentCampaignFormData;
  validateFormRef: (validateFn: () => any) => void;
  error: any;
  isEditPage: boolean;
}

interface State {
  showConditionBuilder: boolean;
}

interface ValidationErrors {
  ownerErrors: string[];
  conditionErrors: string[];
  actionErrors: string[];
  limitErrors: string[];
}

export class ScenarioPage extends React.Component<Props, State> {
  validateActionForm: () => any;
  validateConditionForm: () => any;

  constructor(props: Props) {
    super(props);
    this.props.validateFormRef(this.validateForm);

    // Validation Reference
    this.validateActionForm = () => { // To be overriden by ActionSection component
    };
    this.validateConditionForm = () => { // To be overriden by EventSection component
    };

    const selectedOwner = _.get(props.formData, 'owner', '');
    if (!_.isEmpty(selectedOwner)) {
      props.getListRuleTypes(selectedOwner, this.props.targetUserType);
    }

    this.state = {
      showConditionBuilder: false,
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    const targetUserType = this.props.targetUserType;
    const prevOwner = _.get(this.props, 'formData.owner', '');
    const owner = _.get(nextProps, 'formData.owner', '');
    if (!_.isEmpty(owner) && prevOwner !== owner) {
      this.props.getListRuleTypes(owner, targetUserType);
    }
  }

  validateForm = (): ValidationErrors => {
    // Validate Owner
    const { formData } = this.props;
    let ownerSectionErrors: string[] = [];
    const owner = _.get(formData, 'owner', '');
    if (owner === 'quest') {
      if (_.isEmpty(_.get(formData, 'ownerReferenceID', ''))) {
        ownerSectionErrors = [...ownerSectionErrors, "Owner Reference ID can't be blank"];
      }
    }

    // Validate Limit
    let limitSectionErrors: string[] = [];
    _.forEach(LIMIT_ITEMS, limitItem => {
      if (_.get(formData, limitItem.inputKey, 0) === 0 && !_.get(formData, limitItem.checkboxKey, false)) {
        limitSectionErrors = [...limitSectionErrors, `${limitItem.label} can't be 0`];
      }
    });

    return {
      ownerErrors: ownerSectionErrors,
      conditionErrors: this.validateConditionForm(),
      actionErrors: this.validateActionForm(),
      limitErrors: limitSectionErrors,
    };
  }

  handleEventSelection = (event: any, data: any) => {
    // Set Event
    const eventType = _.get(data, 'value', '');
    let mandatoryCondition = {};
    // Auto set value for currency condition
    if (this.isRequireCurrencyCondition(eventType)) {
      mandatoryCondition = {
        selectedCurrency: this.props.country.currency,
      };
    }
    this.props.handleFormDataChange({ eventType, mandatoryCondition });
  }

  isRequireCurrencyCondition(eventType: string): boolean {
    // Add needCurrency mandatory condition
    const { listRuleTypes, targetUserType } = this.props;
    const { ruleTypes } = getRuleTypesForConditionNode(listRuleTypes, targetUserType, eventType);
    const { needCurrency } = getConditionsFlag(ruleTypes);
    return needCurrency;
  }

  handleOwnerSelection = (event: any, data: any) => {
    const { formData } = this.props;
    if (!_.isEmpty(formData.eventType)) {
      const confirmed = window.confirm('Changing owner will reset the event, condition and actions');
      if (!confirmed) {
        event.preventDefault();
        return;
      }
      this.setState({ showConditionBuilder: false });
    }

    const owner = _.get(data, 'value', '');
    this.props.handleFormDataChange({ owner });
  };

  handleRuleChange = (condition: any) => {
    this.props.handleFormDataChange({ condition });
  };

  handleInputChange = (event: any, { name, value }: { name: string; value: string }) => {
    const newFormData = this.props.formData;
    _.set(newFormData, name, value);
    this.props.handleFormDataChange({ ...newFormData });
  };

  handleDeleteEvent = () => {
    const { formData } = this.props;
    if (!_.isEmpty(formData.actions) || !_.isEmpty(formData.condition)) {
      const confirmed = window.confirm('Removing event will remove all the conditions and actions');
      if (!confirmed) {
        return;
      }
    }

    this.setState({ showConditionBuilder: false });
    this.props.handleFormDataChange({ eventType: '', actions: [], mandatoryCondition: {} });
  };

  render() {
    const { formData, country, listRuleTypes, targetUserType, campaign, error, isEditPage } = this.props;
    const isLoadingRuleTypes = isRequestsPending(this.props.getListRuleTypesRequest);

    // Owners
    const selectedOwner = _.get(formData, 'owner', '');
    const ownerReferenceID = _.get(formData, 'ownerReferenceID', '');

    // Events
    const eventTypesObject = getEventTypesList(listRuleTypes, targetUserType);
    const selectedEventType = _.get(formData, 'eventType', ''); // e.g: nRideComplete
    const eventTypeData = _.find(_.get(listRuleTypes, targetUserType), { eventType: selectedEventType }); // e.g: {eventType:"onRideComplete", noun: "Ride Complete", ..."}
    const eventNoun = _.get(eventTypeData, 'noun', ''); // e.g: Ride Complete
    const eventDescription = _.get(eventTypeData, 'description', '');

    // Conditions
    const { ruleTypes, type } = getRuleTypesForConditionNode(listRuleTypes, targetUserType, selectedEventType);
    const conditionPayload = _.get(formData, 'condition', {});// {lhs: 'var.passenger.ID', operator: 'eq', rhs: 12345}
    const ownerErrors = _.get(error, 'ownerErrors', []);
    const limitErrors = _.get(error, 'limitErrors', []);

    return (<React.Fragment>
      <Row className={'sub-section-row form-row'} style={{ margin: '0 0 40px 0', paddingTop: 0, border: 0 }}>
        <h3 style={{ fontWeight: 500 }}> Select Owner</h3>

        <div className={'panel'}>
          <Row>
            {!_.isEmpty(ownerErrors) &&
              <div className="ui negative message">
                <div className="header"><span className="validation-icon" />
                  {_.map(ownerErrors, (error) => <p key={error}>{error}</p>)}
                </div>
              </div>
            }
            <Col span={12}>
              <Form.Select
                required
                label="Owner"
                id="Owner"
                name="owner"
                options={TRIDENT_OWNERS}
                value={selectedOwner}
                onChange={this.handleOwnerSelection}
              />
            </Col>
            {selectedOwner === 'quest' && <Col span={12}>
              <FormInputWithError
                name="ownerReferenceID"
                {...this.props}
              >
                <label>Owner Reference ID <span className={'red-asterisk'}>*</span></label>
                <Form.Input
                  required
                  name={'ownerReferenceID'}
                  value={ownerReferenceID}
                  onChange={this.handleInputChange}
                  // onBlur={this.props.handleControlBlur}  //TODO: Find out later
                />
              </FormInputWithError>
            </Col>
            }
          </Row>
        </div>
      </Row>

      {!_.isEmpty(selectedOwner) &&
        <ProgressiveContainer isLoading={isLoadingRuleTypes}>

          {/* ------ Event -----*/}
          <Row className={'sub-section-row'}>
            <h3>Select Event</h3>
            <h4>Event Name</h4>
            {_.isEmpty(selectedEventType) &&
              <EventDropdown
                eventTypesObject={eventTypesObject} selectedEventName={'Add Event'}
                handleEventSelection={this.handleEventSelection}
                name="event"
              />
            }

            {(!_.isEmpty(selectedEventType) && !_.isEmpty(ruleTypes)) &&
              <div className={'panel'}>
                <EventSection
                  eventNoun={eventNoun}
                  eventDescription={eventDescription}
                  country={country}
                  ruleTypes={ruleTypes}
                  formData={formData}
                  handleDeleteEvent={this.handleDeleteEvent}
                  handleFormDataChange={this.props.handleFormDataChange}
                  validateFormRef={(validateCondition) => this.validateConditionForm = validateCondition}
                  errors={_.get(error, 'conditionErrors', [])}
                  isEditPage={isEditPage}
                />

                {/* ------ Condition Builder -----*/}
                {!_.isEmpty(conditionPayload) || this.state.showConditionBuilder ?
                  <FormInputWithError
                    name="condition"
                    {...this.props}
                  >
                    <RuleBuilder
                      key={`rule-builder-${type}`}
                      defaultValue={conditionPayload}
                      onChange={this.handleRuleChange}
                      config={RuleBuilderConfig}
                      type={type}
                      systemType="newtrident"
                      ruleTypes={ruleTypes}
                    />
                  </FormInputWithError>
                  : <div
                    className={'borderless-btn'} style={{ marginTop: '20px' }}
                    onClick={() => this.setState({ showConditionBuilder: true })}
                  >
                    <a> + Add Condition </a>
                  </div>
                }
              </div>
            }
          </Row>

          {/* ------ Action And Limit -----*/}
          {!_.isEmpty(selectedEventType) &&
            <React.Fragment>
              <ActionSection
                formData={formData}
                listRuleTypes={listRuleTypes}
                targetUserType={targetUserType}
                campaign={campaign}
                selectedEventType={selectedEventType}
                handleFormDataChange={this.props.handleFormDataChange}
                validateFormRef={(validateAction) => this.validateActionForm = validateAction}
                errors={_.get(error, 'actionErrors', {})}
              />

              <LimitSection
                errors={limitErrors}
                formData={formData}
                handleInputChange={this.handleInputChange}
                handleFormDataChange={this.props.handleFormDataChange}
              />
            </React.Fragment>
          }

        </ProgressiveContainer>
      }
    </React.Fragment>);
  }
}

const mapStateToProps = (state: any) => {
  return {
    getListRuleTypesRequest: _.get(
      state.requests,
      getRequestStateKey(GET_LIST_RULE_TYPE),
      {},
    ),
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  getListRuleTypes: (owner: string, targetUserType: string) => {
    dispatch(getListRuleTypes({ owner, targetUserType }));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ScenarioPage);
